<div class="card" (click)="showAmounts.emit(true)" [ngClass]="{'-schedule': schedule}">
  <div class="card__detail">
    <span class="card__title" [ngClass]="{'card__title--disabled' : enable === false}" >
      Tu recarga (MXN)
    </span>
    <span class="card__amount-label" [ngClass]="{'card__amount-label--disabled' : enable === false}" *ngIf="!amount">
      Selecciona un monto
    </span>
    <span class="card__amount-detail" [ngClass]="{'-error': showError}" *ngIf="amount">
      {{amount | currency: 'MXN':'symbol':'1.2-2'}}
    </span>
    <span class="error" *ngIf="showError">
      No cuentas con saldo suficiente
    </span>
  </div>
  <div class="card__arrow">
    <flame-icon size="xs" class="chevron-right" fontIcon="chevron-right"></flame-icon>
  </div>
</div>
<div *ngIf="!schedule" class="info" (click)="showConsiderations.emit(true)">
  <p>Consideraciones de recargas</p>
  <flame-icon size="xs" class="chevron-right" fontIcon="chevron-right"></flame-icon>
</div>
